export default __webpack_public_path__ + "static/media/chevron.c595a938.svg";